import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { updateRendezVous } from "./rendezVousSlice";

// Thunk pour récupérer les rendez-vous avec un filtre par statut
export const fetchRendezvousByStatus = createAsyncThunk(
  "rendezvous/fetchRendezvousByStatus",
  async (status = "", { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}prestataire/appointments${
        status && status !== "all" ? `?status=${status}` : ""
      }`;

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return {
        status: status || "all",
        data: response.data?.data?.appointments?.data || [],
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Thunk pour récupérer les demandes de rendez-vous
export const fetchDemandesRendezvous = createAsyncThunk(
  "rendezvous/fetchDemandesRendezvous",
  async ({ page = 1, perPage = 5 } = {}, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}etablissement-appointments?demande=1&page=${page}&per_page=${perPage}`;

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // return response.data?.data?.appointments?.data || [];
      const data = response.data?.data?.appointments;
      return {
        data: data?.data || [],
        current_page: data?.current_page,
        total: data?.total,
        per_page: data?.per_page,
        last_page: data?.last_page,
        next_page_url: data?.next_page_url,
        prev_page_url: data?.prev_page_url,
      };
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Thunk pour récupérer les rendez-vous sauf ceux avec le statut "enattente"
export const fetchRendezvousExceptEnAttente = createAsyncThunk(
  "rendezvous/fetchRendezvousExceptEnAttente",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}etablissement-appointments`;

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log("response:", response);
      // Filtrer les rendez-vous côté client
      const filteredData = (
        response.data?.data?.appointments?.data || []
      ).filter((rdv) => rdv.status !== "enattente");

      return filteredData;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Thunk pour récupérer les données de l'agenda
export const fetchCalendarData = createAsyncThunk(
  "rendezvous/fetchCalendarData",
  async (_, { rejectWithValue }) => {
    //console.log("fetch data excuted");
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}prestataire/calendar`;

      const response = await axios.get(apiUrl, {
        headers: { Authorization: `Bearer ${token}` },
      });
       console.log("response?.data?.appointments:", response);
      return response?.data?.data || [];
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
// Thunk pour créer un rendez-vous manuel
export const createManualAppointment = createAsyncThunk(
  "rendezvous/createManualAppointment",
  async (appointmentData, { rejectWithValue, dispatch }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}appointments/manual`;

      const response = await axios.post(apiUrl, appointmentData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      dispatch(fetchCalendarData());
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);

// Thunk pour créer un créneau d'indisponibilité
export const createUnavailableAppointment = createAsyncThunk(
  "rendezvous/createUnavailableAppointment",
  async (unavailableData, { rejectWithValue, dispatch }) => {
    try {
      const token = localStorage.getItem("token");
      const apiUrl = `${process.env.REACT_APP_API_URL}appointments/unavailable`;

      const response = await axios.post(apiUrl, unavailableData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      dispatch(fetchCalendarData());
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.message,
        status: error.response?.status,
        data: error.response?.data,
      });
    }
  }
);
//Thunk pour Annuler un rendez-vous Manuel et Indisponibilité
export const cancelRdvManual = createAsyncThunk(
  "appointments/cancelRdvManual",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}appointments/special/${payload?.id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      dispatch(fetchCalendarData());
      return response.data;
    } catch (error) {
      // console.log("error",error)
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const rendezvousSlicePresta = createSlice({
  name: "rendezvous",
  initialState: {
    all: [],
    enAttente: [],
    confirmes: [],
    annules: [],
    passes: [],
    confirmesPassesAnnules: [],
    demandes: [],
    current_page: 1,
    total: 0,
    per_page: 10,
    last_page: 1,
    next_page_url: null,
    prev_page_url: null,
    itemsPerPage: 5,
    sansEnAttente: [],
    calendarData: [],
    allEtablissementEquipes: [],
    selectedRdv: null,
    status: "idle",
    error: null,
  },
  reducers: {
    setSelectedRdv: (state, action) => {
      state.selectedRdv = action.payload;
    },
    clearSelectedRdv: (state) => {
      state.selectedRdv = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRendezvousByStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })

       .addCase(fetchRendezvousByStatus.fulfilled, (state, action) => {
      const { status: fetchedStatus, data } = action.payload;

      state.status = "succeeded";

      if (fetchedStatus === "all") {
        state.all = data;
        // Trier enAttente par date la plus proche
        state.enAttente = data
          .filter((rdv) => rdv.status === "enattente")
          .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
        
        // Trier confirmes par date la plus proche
        state.confirmes = data
          .filter((rdv) => rdv.status === "confirme")
          .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
        
        state.annules = data?.filter((rdv) => rdv.status === "annule");
        state.passes = data?.filter((rdv) => rdv.status === "passe");

        state.confirmesPassesAnnules = data?.filter((rdv) =>
          ["confirme", "passe", "annule"].includes(rdv.status)
        );
      } else {
        if (fetchedStatus === "enattente") {
          state.enAttente = data.sort(
            (a, b) => new Date(a.start_time) - new Date(b.start_time)
          );
        } else if (fetchedStatus === "confirme") {
          state.confirmes = data.sort(
            (a, b) => new Date(a.start_time) - new Date(b.start_time)
          );
        } else if (fetchedStatus === "annule") state.annules = data;
        else if (fetchedStatus === "passe") state.passes = data;
        
        state.confirmesPassesAnnules = [
          ...state.confirmes,
          ...state.annules,
          ...state.passes,
        ];
      }
    })
      .addCase(fetchRendezvousByStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.loading = false;
      })
      //Demandes de Rendez-vous
      .addCase(fetchDemandesRendezvous.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchDemandesRendezvous.fulfilled, (state, action) => {
        state.status = "succeeded";
        //  state.demandes = action.payload;
        state.demandes = action.payload.data;

        state.demandesPagination = {
          current_page: action.payload.current_page || 1,
          total: action.payload.total || 0,
          per_page: action.payload.per_page || 10,
          last_page: action.payload.last_page || 1,
          next_page_url: action.payload.next_page_url,
          prev_page_url: action.payload.prev_page_url,
          itemsPerPage: action.payload.itemsPerPage,
        };
      })
      .addCase(fetchDemandesRendezvous.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      //les rendez-vous sauf ceux avec le statut "enattente"
      .addCase(fetchRendezvousExceptEnAttente.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRendezvousExceptEnAttente.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.sansEnAttente = action.payload;
      })
      .addCase(fetchRendezvousExceptEnAttente.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      //les rendez-vous de l'agenda
      .addCase(fetchCalendarData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchCalendarData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.calendarData = action.payload;
        state.allEtablissementEquipes =
          action.payload.all_etablissement_equipes || [];
      })
      .addCase(fetchCalendarData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      //mise à jour de la liste rendez-vous locale aprés action update
      // .addCase(updateRendezVous.fulfilled, (state, action) => {
      //   console.log("state in fulfilled", state);
      //   console.log("action.payload", action.payload);

      //   let newCalendarData = state.calendarData;
      //   console.log(
      //     "action.payload.appointment.status",
      //     action.payload.appointment.status
      //   );
      //   //if status = annule
      //   if (action.payload.appointment.status == "annule") {
      //     newCalendarData = {
      //       ...newCalendarData,
      //       appointment: {
      //         ...newCalendarData?.appointment,
      //         data: newCalendarData?.appointment?.data?.filter(
      //           (rdv) => rdv?.id !== action.payload.appointment?.id
      //         ),
      //       },
      //     };
      //   } else {
      //     newCalendarData?.appointments?.data?.map((rdv) => {
      //       if (rdv?.id == action.payload.appointment?.id) {
      //         rdv.status = action.payload.appointment?.status;
      //       }
      //       return rdv;
      //     });
      //   }
      //   state.calendarData = newCalendarData;
      // })

      // Création d'un rendez-vous manuelle
      .addCase(createManualAppointment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createManualAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(createManualAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      // Création d'une Indisponibilité
      .addCase(createUnavailableAppointment.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(createUnavailableAppointment.fulfilled, (state, action) => {
        state.status = "succeeded";
        // Tu peux ajouter une logique ici si tu veux stocker ou utiliser la réponse
      })
      .addCase(createUnavailableAppointment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(cancelRdvManual.pending, (state) => {
        state.loading = true;
      })
      // Annulation d'un Rendez-vous Manuel et une Indisponibilité
      .addCase(cancelRdvManual.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        // Optionnel : mettre à jour l'état local si tu stockes la liste des rendez-vous
      })
      .addCase(cancelRdvManual.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload || "Erreur lors de l'annulation du rendez-vous.";
      });
  },
});

export const { setSelectedRdv, clearSelectedRdv } =
  rendezvousSlicePresta.actions;

export default rendezvousSlicePresta.reducer;
